import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import List from '../List/List.js';

const USPList = ({ usps , className  })=>{
    const { getLabel  } = useIntl();
    const items = React.useMemo(()=>usps.map((usp)=>getLabel(usp, {
                hideLabelKey: true
            })
        ).filter((item)=>Boolean(item)
        )
    , [
        getLabel,
        usps
    ]);
    return /*#__PURE__*/ React.createElement(List, {
        icon: "checkmark",
        items: items,
        className: className
    });
};

export { USPList, USPList as default };
//# sourceMappingURL=USPList.js.map
